import "./ThemeModal.css";

export default function ThemeModal({ open, onChoose }) {
  if (!open) return null;

  return (
    <div className="tm-overlay">
      <div className="tm-card">
        <div className="tm-title">
          Choisis ton mode <span className="tm-muted">/ Choose your mode</span>
        </div>

        <div className="tm-sub">
          Choisis le fond qui te convient maintenant.
          <br />
          <span className="tm-muted">Pick the background that fits you right now.</span>
        </div>

        <div className="tm-actions">
          <button className="tm-btn tm-day" onClick={() => onChoose?.("day")}>
            <div>Mode Jour</div>
            <div className="tm-muted">Day mode</div>
          </button>

          <button className="tm-btn tm-night" onClick={() => onChoose?.("night")}>
            <div>Mode Nuit</div>
            <div className="tm-muted">Night mode</div>
          </button>
        </div>
      </div>
    </div>
  );
}
